/**
 * Parse WKT point string to coordinates
 */
export const parseWKTPoint = (wkt: string): [number, number] | null => {
  if (!wkt) return null

  // Parse WKT POINT format: "POINT(longitude latitude)"
  const match = wkt.match(/POINT\s*\(\s*([-\d.]+)\s+([-\d.]+)\s*\)/i)
  if (!match) return null

  const lon = parseFloat(match[1])
  const lat = parseFloat(match[2])

  if (isNaN(lon) || isNaN(lat)) return null

  return [lon, lat]
}
